import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

const baseEndpoint = "/api/talentDashboard/getPaidV2/admin/accounts";

export default function useGetPaidAdminAccounts(influencerId) {
  const url = React.useMemo(() => {
    if (!influencerId) return null;
    const params = new URLSearchParams({
      influencer_id: String(influencerId),
    });
    return `${baseEndpoint}?${params.toString()}`;
  }, [influencerId]);

  const { data, error, mutate } = useSWR(url, fetcher);

  return {
    accounts: data?.accounts ?? [],
    isLoading: Boolean(influencerId) && !data && !error,
    error,
    refresh: mutate,
  };
}
